import React, { useMemo } from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';
import { WorkOrderTaskUserList } from '~/workorder/types';
import Icon from '~/app/common/Icon';
import { getWorkOrderTaskUserTotalHours } from '~/workorder/helper';
import { formatTaskHoursLogDate } from '~/workorder/helper';

export type UsersComponent = React.FC<{ users: WorkOrderTaskUserList[]}>;

const Users: UsersComponent = ({ users }) => {
    const { t } = useTranslation('workorder');
    const { t: tMaterial } = useTranslation('material');

    const totalHours = useMemo(
        () => users.reduce((sum, user) => sum + getWorkOrderTaskUserTotalHours(user), 0),
        [users],
    );

    return (
        <div className={classes['card']}>
            <div className={classes['section-header']}>
                <h2 className={classes['section-header-title']}>
                    <Icon name="schedule" size={20} className={classes['section-header-icon']} />
                    {t('detail.taskTimeRegistrations')}
                </h2>
                {false && <button type="button" className={classes['add-action']} aria-hidden tabIndex={-1}>
                    + {tMaterial('add')}
                </button>}
            </div>
            {users.length === 0 ? (
                <p className={classes.empty}>{t('detail.noTimeRegistrations')}</p>
            ) : (
                <>
                    <div className={classes.list}>
                        {users.map(user => {
                            const hours = getWorkOrderTaskUserTotalHours(user);
                            const logDate = formatTaskHoursLogDate(user.hoursLogDate);
                            return (
                                <div key={user.id} className={classes['list-row']}>
                                    <div className={classes['row-main']}>
                                        <p className={classes['row-name']}>{user.name || t('detail.system')}</p>
                                        {logDate && <p className={classes['row-meta']}>{logDate}</p>}
                                    </div>
                                    <div className={classes['row-actions']}>
                                        <span className={classes['row-value']}>
                                            {t('detail.taskHoursShort', { hours })}
                                        </span>
                                        {false && <Icon name="delete" size={20} className={classes['row-delete']} />}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className={classes['total-bar']}>
                        <span>{t('detail.taskTimeTotal')}</span>
                        <span className={classes['total-value']}>
                            {t('detail.taskTimeTotalHours', { hours: totalHours })}
                        </span>
                    </div>
                </>
            )}
        </div>
    );
}

export default Users;